const content = {
    microsoft_device_id: {
        en: {
            summary_no_video_html: `
            <h2>Before you start</h2>
            <p>It's important you complete each step, or we won't be able to process your payment! Please read all 4 steps before starting.</p>
            <h2 class="hint-title" style="margin-top:1.5rem;">Helpful hint</h2>
            <p>Hold your phone 4+ inches away from your PC and tap the screen to focus on the ID. Avoid using zoom where possible..</p>`,
          steps: [
            {
              step_type: 'numbered_step',
              number: '1',
              description_html: `<p>Click open your PC <b>Settings</b>.</p>`
            },
            {
              step_type: 'numbered_step',
              number: '2',
              description_html: `<p>Click <b>About</b> under System.</p>`
            },
            {
              step_type: 'numbered_step',
              number: '3',
              description_html: `<p>Take a photo of this settings page.<br/><span class="hint-title">Please make sure the Device ID is clear.</span></p>`
            },
            {
              step_type: 'numbered_step',
              number: '4',
              description_html: `<p>Upload your photo.</p>`
            }
          ],
          finished_steps_text: 'I have followed the steps above and my Device ID is clear and visible',
        }
    },
    edge_data_upload: {
        en: {
            summary_no_video_html: `
            <p>To upload your Microsoft Edge data — the data that you downloaded in part one, simply follow the instructions below:</p>`,
            steps: [
              {
                  step_type: 'numbered_step',
                  number: '1',
                  description_html: `
                    <p>Navigate to where you downloaded your Microsoft Edge data. Typically, this is in your "Downloads" folder, on either your
                        phone or your desktop/laptop.</p>`
              },
              {
                  step_type: 'numbered_step',
                  number: '2',
                  description_html: `
                        <p>Upload your file below.</p>`
              },
            ],
            finished_steps_text: 'I have my Microsoft Edge data ready for upload',
        }
    }
};

export const microsoftDataTypes = {
    microsoft_device_id: {
        data_type: 'microsoft_device_id',
        data_type_description: 'Microsoft Device ID',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/retro/microsoft.jpg',
        capture_type: 'image',
        require_consent: true,
        generic: {
            ...content.microsoft_device_id,
        }
      },
    edge_data_upload: {
        data_type: 'edge_data_upload',
        data_type_description: 'Microsoft Edge Data',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/retro/microsoft.jpg',
        capture_type: 'file',
        generic: {
            ...content.edge_data_upload,
        }
      }
};